import { BCPM } from '../libs/brightcove-player-manager';

import './brightcove.scss';

/**
 * version    1.0
 * class      <type> (Brightcove)
 * classdesc  Brighcove: to be used just to init the BCPM library.
 */
export class Brightcove {
  constructor() {
    // Brightcove
    //
    // Anticipa, per ogni .video-container, la generazione del markup necessario all'aspect ratio intrinseco e la poster image.
    // La poster image inizialmente sarà non cliccabile e senza icona di play.
    // L'icona di play verrà aggiunta e resa cliccabile solo al caricamento dello script brightcove, a seguito della initManager().
    if ($('.video-container').length > 0) {
      BCPM.prepare();

      // Ritardo l'inizializzazione di BRIGHTCOVE dopo tutto il resto.
      $(window).on('load', () => {
        if ($('.video-container').length > 0) {
          // Carica lo script brightcove e a seguire inizializza i video presenti in pagina
          BCPM.initManager();
        }
      });
    }
  }
}
